var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionPendingModal',{attrs:{"message":"Purchasing the Core Training Bundle"}},[(_vm.purchaseinProgressText)?_c('ContentfulRichText',{attrs:{"content":_vm.purchaseinProgressText}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }